/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Plan_Change_Option_IncludedInputs */

const fr_membership_plan_change_option_included = /** @type {(inputs: Membership_Plan_Change_Option_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'accès 6h-23h est inclus dans cette formule : l'option facturée à part sera retirée.`)
};

/**

* @param {Membership_Plan_Change_Option_IncludedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_option_included = /** @type {((inputs?: Membership_Plan_Change_Option_IncludedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_Option_IncludedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_option_included(inputs)
});